import qs from "qs";
import storeProvider from "../store/StoreProvider";
import * as Storage from "./LocalStorage";
import axios from "axios";

const badRespnseCodes = [401, 400];

export const axiosService = (
  API,
  payload,
  authNeeded = true,
  type = "POST"
) => {
  const userInfo = storeProvider.getUserInfo();
  let authData = authNeeded ? { token: userInfo.token } : {};

  let header = {
    "content-type": "application/x-www-form-urlencoded;charset=utf-8",
    Authorization: authData.token,
  };

  if (type === "GET" || type === "PUT") {
    header["content-type"] = "application/json";
  }

  // ✔ Decide correct body format
  let dataToSend =
    header["content-type"] === "application/json"
      ? { ...authData, ...payload }         // send proper JSON
      : qs.stringify({ ...authData, ...payload }); // urlencoded

      return axios({
        method: type,
        url: API,
        headers: header,
        params:
          type === "GET" || type === "DELETE"
            ? { ...payload }
            : {},
      
        data: dataToSend, // ← FIXED
      })
    .then(function (response) {
      const resData = response.data;

      if (!resData.success) {
        const errorRes = {
          status: false,
          data: resData.data,
          code: resData.code,
          msg: resData.message,
          success: true,
        };

        return authNeeded ? checkSession(errorRes) : errorRes;
      }

      return { status: true, data: resData, success: true };
    })
    .catch(function (res) {
      if (
        res?.response?.status &&
        badRespnseCodes.indexOf(res.response.status) > -1
      ) {
        checkResponseCode(res);
      }

      return {
        status: false,
        ...res.response?.data,
      };
    });
};



const checkResponseCode = (data) => {
  Storage.clear();
  window.location.reload();
};

const checkSession = function (data) {
  let message = data.msg;

  if (typeof message === "string" || message instanceof String) {
    message = message ? message.toLowerCase() : "";
    message = message.trim();
    if (
      message === "id or token wrong." ||
      message === "email id or token wrong." ||
      message === "invalid signature"
    ) {
      const sessionKey = storeProvider.getSessionKey();
      console.log(sessionKey);
      Storage.remove(sessionKey);
      window.location.reload();
      return { ...data, sessionExpired: true };
    }
  }

  return { ...data, sessionExpired: false };
};
